'use strict';

function factory() {
  /**
   * Checks if the node at w[j] is marked
   *
   * @param {Array}   w               The array
   * @param {Number}  j               The array index
   *
   * Reference: http://faculty.cse.tamu.edu/davis/publications.html
   */
  var csMarked = function csMarked(w, j) {
    // check node is marked
    return w[j] < 0;
  };

  return csMarked;
}

exports.name = 'csMarked';
exports.path = 'algebra.sparse';
exports.factory = factory;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/algebra/sparse/csMarked.js
// module id = 396
// module chunks = 0